import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Projects = lazy(() => import('../pages/projects/page'));
const ProjectDetail = lazy(() => import('../pages/projects/detail/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/proyectos',
    element: <Projects />
  },
  {
    path: '/proyectos/:id',
    element: <ProjectDetail />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
